import React, { useState, useRef, useEffect } from "react";

const PropertyDetailCard = ({
  property,
  setShowAddBuildingModel,
  setSelectedpropertie,
  setShowDeleteModel,
  setShowEditPropertyModel,
  setInitialPropertyName,
  setShowEditBuildingModal,
  isActionsDisabled,
}) => {
  const cardId = property?.unid;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    }

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  function handleAddBuildingClick() {
    setShowAddBuildingModel(true);
  }

  function handleRemoveProperty() {
    setShowDeleteModel(true);
    setDropdownOpen(false); // close dropdown after action
  }

  function handleEditProperty() {
    setSelectedpropertie(property);
    setInitialPropertyName(property?.name);
    setShowEditPropertyModel(true);
    setDropdownOpen(false); // close dropdown after action
  }

  function handleEditBuilding() {
    setShowEditBuildingModal(true);
    setDropdownOpen(false); // close dropdown after action
  }

  return (
    <>
      <div
        className="property bg-white dark:darkThemeGradiantBg px-4 py-3 rounded-lg shadow-appShadow h-52"
        onClick={() => {
          setSelectedpropertie(property);
        }}
        data-testid={`property-card-${cardId}`}
      >
        <div className="flex flex-col h-full gap-3">
          <div className="propertyBody flex-col gap-4 flex grow">
            <div className="flex flex-col gap-4">
              <p title={property?.name} className="propertyName text-dark-grey dark:text-white font-semibold text-base leading-5 lg:text-lg lg:leading-7 tracking-[0.27px]  max-w-[85%] w-full line-clamp-2 text-ellipsis" data-testid={`property-card-name-${cardId}`}>
                {property?.name}
              </p>
            </div>
            <div className="buildingsInfo">
              <p className="text-dark-grey dark:text-white text-base leading-5 font-normal tracking-[0.021px]">
                Buildings
              </p>
              <p className="text-dark-grey dark:text-white text-base leading-5 font-semibold tracking-[0.021px] mt-1" data-testid={`property-card-buildings-count-${cardId}`}>
                {property?.buildings.length}
              </p>
            </div>
          </div>
          <div className="propertyFooter border-t border-grey basis-9">
            <div className="flex items-center justify-between h-full pt-3">
              <div className="addBuilding">
                <button
                  className={`text-theme text-base leading-5 font-semibold tracking-[-0.32px] ${
                    isActionsDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                  }`}
                  onClick={() => {
                    if (isActionsDisabled) return;
                    handleAddBuildingClick();
                  }}
                  disabled={isActionsDisabled}
                  data-testid={`property-card-add-building-button-${cardId}`}
                >
                  Add Building
                </button>
              </div>
              <div
                className="dropdownHolder relative"
                ref={dropdownRef}
              >
                <button
                  onClick={() => {
                    if (isActionsDisabled) return;
                    setDropdownOpen(!dropdownOpen);
                  }}
                  className={`flex items-center gap-2 text-primaryText font-semibold text-sm leading-6 tracking-[0.021px] ${
                    isActionsDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                  }`}
                  disabled={isActionsDisabled}
                  aria-disabled={isActionsDisabled}
                  data-testid={`property-card-actions-toggle-${cardId}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle cx="5" cy="12" r="2" fill={isActionsDisabled ? "#AFC3BC" : "#FF8C65"} />
                    <circle cx="12" cy="12" r="2" fill={isActionsDisabled ? "#AFC3BC" : "#FF8C65"} />
                    <circle cx="19" cy="12" r="2" fill={isActionsDisabled ? "#AFC3BC" : "#FF8C65"} />
                  </svg>
                </button>
                {!isActionsDisabled && dropdownOpen && (
                  <div className="dropdownContent min-w-24 w-max absolute bottom-full right-0 bg-[#FFF4D1] dark:bg-darkThemeDropdownBg dark:text-white rounded-lg shadow-appShadow z-10 dark:shadow-darkThemeDropdownMenuShadow" data-testid={`property-card-actions-menu-${cardId}`}>
                    <ul className="flex flex-col">
                      <li
                        className="text-dark-grey dark:text-white font-medium text-sm leading-6 cursor-pointer px-3 py-1 rounded border-b border-grey dark:border-darkThemeBorder"
                        onClick={handleEditProperty}
                        data-testid={`property-card-edit-property-button-${cardId}`}
                      >
                        Edit Property
                      </li>
                      <li
                        className="text-dark-grey dark:text-white font-medium text-sm leading-6 cursor-pointer px-3 py-1 rounded border-b border-grey dark:border-darkThemeBorder"
                        onClick={handleEditBuilding}
                        data-testid={`property-card-edit-building-button-${cardId}`}
                      >
                        Edit Building
                      </li>
                      <li
                        className="text-dark-grey dark:text-white font-medium text-sm leading-6 cursor-pointer px-3 py-1 rounded"
                        onClick={handleRemoveProperty}
                        data-testid={`property-card-delete-property-button-${cardId}`}
                      >
                        Delete Property
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyDetailCard;
